import React, { useEffect, useState } from "react";

import { Modaal, Buttton, CustomDatePicker, Inputs, SelectO } from "..";
import { PiCalendar, PiClock, PiUserCircle } from "react-icons/pi";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { actionPatient } from "../../redux/actions";
import { useTranslation } from "react-i18next";
import { useAlert, useSnackBar, } from "../../contexts";

const CancelAppointmentModal = ({ show, onHide, loginData, appointmentGuid, setSelectedAppointmentGuid, dashboard }) => {
    const { t } = useTranslation();
    const { showAlert } = useAlert();
    const { showSnackBar } = useSnackBar();
    const dispatch = useDispatch();
    const [appointmentDate, setAppointmentDate] = useState();

    const [options, setOptions] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState(null);

    const [credentials, setCredentials] = useState({
        appDate: "",
        appointmentType: 2,
    });

    const [queryParam, setQueryParam] = useState({
        appointmentGuid: "",
        cancelReason: "",
        canceledBy: 1,
        suggestedDateTime: selectedOptions?.value || "",
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (appointmentGuid) {
            setQueryParam((prev) => ({
                ...prev,
                appointmentGuid: appointmentGuid,
            }));
        }
    }, [appointmentGuid]);

    useEffect(() => {
        if (credentials.appDate) {
            dispatch(
                actionPatient.postAllAvailability(credentials, loginData?.userGuid)
            );
        }
    }, [credentials, credentials.appDate, dispatch, loginData?.userGuid]);


    const postBookedAppointmentData = useSelector(
        (state) => state.patient.postBookedAppointmentData?.data
    );

    const postAllAvailabilityData = useSelector(
        (state) => state.patient.postAllAvailabilityData?.data
    );

    useEffect(() => {
        if (postAllAvailabilityData) {
            const selectedDateData =
                postAllAvailabilityData?.result?.availableSlots.find(
                    (item) => item.currentDate.split("T")[0] === credentials.appDate
                );

            if (selectedDateData) {
                const newOptions = selectedDateData.availableTime.map((time) => ({
                    value: time,
                    label: new Date(time).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                    }),
                }));

                setOptions(newOptions);
            }
        }
    }, [postAllAvailabilityData, credentials.appDate]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setQueryParam((prevCredentials) => ({
            ...prevCredentials,
            [name]: value,
        }));
    };

    const handleDateChange = (date) => {
        if (date) {
            setAppointmentDate(date);
            const localDate = new Date(
                date.getTime() - date.getTimezoneOffset() * 60000
            );
            const year = localDate.getFullYear();
            const month = String(localDate.getMonth() + 1).padStart(2, "0");
            const day = String(localDate.getDate()).padStart(2, "0");
            const formattedDate = `${year}-${month}-${day}`;

            setCredentials((prev) => ({
                ...prev,
                appDate: formattedDate,
            }));
            setSelectedOptions();
            setOptions([]);
        }
    };

    const handleClose = () => {
        setAppointmentDate();
        setOptions([]);
        setSelectedOptions(null);
        setCredentials({
            appDate: "",
            appointmentType: 2,
        });
        setQueryParam({
            cancelReason: "",
            canceledBy: 1,
            suggestedDateTime: "",
        });
        setErrors({});
        onHide();
    };

    const handleSave = () => {

        dispatch(
            actionPatient.postCancelAppointment(
                queryParam.appointmentGuid,
                queryParam.cancelReason,
                queryParam.canceledBy,
                queryParam.suggestedDateTime,

                (error, response) => {
                    if (error) {
                        if (error.data) {
                            if (error.data.statusCode === 400) {
                                if (error.data.error && error.data.error.ValidationErrors) {
                                    error.data.error.ValidationErrors.forEach(
                                        (validationError) => {
                                            console.error(
                                                `${t("Field")}: ${validationError.Field} - ${t(
                                                    "Message"
                                                )}: ${validationError.Message}`
                                            );

                                            showAlert(
                                                "danger",
                                                validationError.Message,
                                                `${t("Error")} : ${validationError.Field}`
                                            );
                                        }
                                    );
                                } else {
                                    showAlert(
                                        "danger",
                                        t("Invalid_credentials"),
                                        `${t("Error")} !`
                                    );
                                }
                            } else {
                                showAlert("danger", t("unexpected_error"), `${t("Error")} !`);
                            }
                        }
                        setAppointmentDate();
                        setOptions([]);
                        setSelectedOptions(null);
                        setCredentials({
                            appDate: "",
                            appointmentType: 2,
                        });
                        setQueryParam({
                            cancelReason: "",
                            canceledBy: 1,
                            suggestedDateTime: "",
                        });
                        setErrors({});
                        setSelectedAppointmentGuid();
                    } else if (response) {
                        if (response.status === 200) {
                            showSnackBar(`${t("appointments.appointment_deleted_successfully")}`, "snackbar-success")
                            if (dashboard) {
                                if (postBookedAppointmentData?.result?.iAppointmentStatus === 2) {
                                    dispatch(
                                        actionPatient.getAppointments(
                                            10,
                                            1,
                                            "",
                                            "",
                                            "",
                                            "",
                                            loginData.userGuid,
                                            2,
                                            "",
                                            "",
                                            null,
                                            null,
                                            loginData?.currencyCode,
                                            loginData.timeZoneId,
                                            null,
                                            null,
                                            null,
                                            loginData?.languageId,
                                            [1, 2, 3], null
                                        )
                                    );
                                    dispatch(
                                        actionPatient.getClinicUpcomingAppointments(
                                            10,
                                            1,
                                            "",
                                            "",
                                            "",
                                            "",
                                            null,
                                            2,
                                            "",
                                            "",
                                            null,
                                            null,
                                            loginData?.currencyCode,
                                            loginData.timeZoneId,
                                            loginData.clinicGuid,
                                            null,
                                            null,
                                            loginData?.languageId,
                                            [1, 2, 3],
                                        )
                                    );
                                } else {
                                    dispatch(
                                        actionPatient.getRequestedAppointments(
                                            10,
                                            1,
                                            "",
                                            "",
                                            "",
                                            "",
                                            loginData.userGuid,
                                            1,
                                            "",
                                            "",
                                            null,
                                            null,
                                            loginData?.currencyCode,
                                            loginData.timeZoneId,
                                            null,
                                            null,
                                            null,
                                            loginData?.languageId,
                                            [1, 2, 3]
                                        )
                                    );
                                    dispatch(
                                        actionPatient.getClinicRequestedAppointments(
                                            10,
                                            1,
                                            "",
                                            "",
                                            "",
                                            "",
                                            null,
                                            1,
                                            "",
                                            "",
                                            null,
                                            null,
                                            loginData?.currencyCode,
                                            loginData.timeZoneId,
                                            loginData.clinicGuid,
                                            null,
                                            null,
                                            loginData?.languageId,
                                            [1, 2, 3]
                                        )
                                    );
                                }

                            } else {
                                if (postBookedAppointmentData?.result?.iAppointmentStatus === 2) {
                                    dispatch(
                                        actionPatient.getAppointments(
                                            10,
                                            1,
                                            "",
                                            "",
                                            "",
                                            "",
                                            loginData.userGuid,
                                            2,
                                            "",
                                            "",
                                            true,
                                            true,
                                            loginData?.currencyCode,
                                            loginData.timeZoneId,
                                            "",
                                            true,
                                            false,
                                            loginData?.languageId,
                                            null, null
                                        )
                                    );
                                    dispatch(
                                        actionPatient.getAppointments(
                                            10,
                                            1,
                                            "",
                                            "",
                                            "",
                                            "",
                                            "",
                                            2,
                                            "",
                                            "",
                                            true,
                                            true,
                                            loginData?.currencyCode,
                                            loginData.timeZoneId,
                                            loginData.clinicGuid,
                                            true,
                                            false,
                                            loginData?.languageId,
                                            null, null
                                        )
                                    );
                                } else {
                                    dispatch(
                                        actionPatient.getAppointments(
                                            10,
                                            1,
                                            "",
                                            "",
                                            "",
                                            "",
                                            loginData.userGuid,
                                            [1, 3],
                                            "",
                                            "",
                                            true,
                                            true,
                                            loginData?.currencyCode,
                                            loginData.timeZoneId,
                                            "",
                                            true,
                                            false,
                                            loginData?.languageId,
                                            null
                                        )
                                    );
                                    dispatch(
                                        actionPatient.getAppointments(
                                            10,
                                            1,
                                            "",
                                            "",
                                            "",
                                            "",
                                            "",
                                            [1, 3],
                                            "",
                                            "",
                                            true,
                                            true,
                                            loginData?.currencyCode,
                                            loginData.timeZoneId,
                                            loginData.clinicGuid,
                                            true,
                                            false,
                                            loginData?.languageId,
                                            null, null, null
                                        )
                                    );
                                }

                            }

                            setSelectedAppointmentGuid();
                            setAppointmentDate();
                            setOptions([]);
                            setSelectedOptions(null);
                            setCredentials({
                                appDate: "",
                                appointmentType: 2,
                            });
                            setQueryParam({
                                cancelReason: "",
                                canceledBy: 1,
                                suggestedDateTime: "",
                            });
                            setErrors({});

                        }
                    }
                }

            )
        );

        onHide();

    };

    return (
        <Modaal.Modaal
            show={show}
            onHide={handleClose}
            size="md"
            centered="true"
            title={<h2 className="exado-title-nine text-capitalize">{t("cancel_appointment")}</h2>}
            bodyContent={
                <>
                    <ul className="cardd-app-ul">
                        <li className="cardd-app-li exado-title-six">
                            <PiUserCircle className="list-icon" />{" "}
                            {postBookedAppointmentData?.result?.patientFirstName}{" "}
                            {postBookedAppointmentData?.result?.patientLastName}
                        </li>
                        <li className="cardd-app-li exado-title-six">
                            <PiClock className="list-icon" />
                            {new Date(
                                postBookedAppointmentData?.result?.appointmentDateTime
                            ).toLocaleTimeString("en-US", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                            })}
                        </li>
                        <li className="cardd-app-li exado-title-six">
                            <PiCalendar className="list-icon" />{" "}
                            {
                                new Date(
                                    postBookedAppointmentData?.result?.appointmentDateTime
                                ).toLocaleDateString("en-GB", {
                                    weekday: "long",
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric",
                                })
                                // .replace(/\//g, " - ")
                            }
                        </li>
                    </ul>
                    <div className="app-date-time-blk">
                        <div className="app-dt">
                            <fieldset
                                className={`frm-fieldset custom-date-picker ${errors.doB ? "error-date" : ""
                                    }`}
                            >
                                <legend className="frm-legend">
                                    {errors.doB ? (
                                        <span className="error-message">{errors.doB}</span>
                                    ) : (
                                        `${t("date")}`
                                    )}
                                </legend>

                                <CustomDatePicker.CustomDatePickerDMY
                                    selected={appointmentDate}
                                    onChange={handleDateChange}
                                    placeholderText="DD - MM - YYYY"
                                    dateFormat="dd-MM-yyyy"
                                    className="customDatePicker"
                                    minDate={new Date()}
                                />
                            </fieldset>
                        </div>
                        <div className="app-dt">
                            <SelectO.SelectO
                                options={options}
                                onChange={(selected) => {
                                    setSelectedOptions(selected);
                                    setQueryParam((prevCredentials) => ({
                                        ...prevCredentials,
                                        suggestedDateTime: selected.value,
                                    }));

                                    setErrors((prevErrors) => ({
                                        ...prevErrors,
                                        selectedOptions: "",
                                    }));
                                }}
                                isSearchable={false}
                                name="appointmentTime"
                                value={selectedOptions}
                                className={`select1 ${errors.selectedOptions ? "select-border-error" : ""
                                    }`}
                                placeholder={t("select_time_slot")}
                                isDisabled={!appointmentDate}
                            />
                            {errors.selectedOptions && (
                                <Form.Text className="error-message noVerify">
                                    {errors.selectedOptions}
                                </Form.Text>
                            )}
                        </div>
                    </div>
                    <Inputs.FormInputs
                        placeholder={t("write_text_here")}
                        type="textarea"
                        label={t("write_message_to_patient")}
                        value={queryParam.cancelReason}
                        onChange={handleChange}
                        name="cancelReason"
                        grpClassname={`form-group }`}
                    />
                </>
            }
            footer={
                <Buttton.Buttton
                    children={t("SEND")}
                    className="btn-solid-Aqua_Teal"
                    onClick={() => handleSave()}
                    disabled={!appointmentDate || selectedOptions === null || !queryParam.cancelReason.trim()}
                />
            }
            backdrop="static"
            className="input-modal cancel-appointment-modal"
        />
    );
};

export default CancelAppointmentModal;
